import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useCart } from "./Components/Cart/CartContext";
import { useModal } from "./ModalContext";
import { CgDanger } from "react-icons/cg";

const ProtectedCheckout = ({ children }) => {
  const { cartItems } = useCart();
  const { openModal } = useModal();
  const navigate = useNavigate();
  const location = useLocation();

  const hasTriggered = useRef(false);
  const isCartEmpty = !cartItems || cartItems.length === 0;

  useEffect(() => {
    if (isCartEmpty && !hasTriggered.current) {
      hasTriggered.current = true;

      openModal(
        <CgDanger size={40} color="#993400" />,
        "Your cart is empty.",
        "Add some items before checking out."
      );

      // 👇 Redirect AFTER modal shows
      setTimeout(() => {
        const previousPage = location.state?.from?.pathname || "/shop";
        navigate(previousPage, { replace: true });
      }, 1500); // adjust timing if needed
    }
  }, [isCartEmpty, openModal, navigate, location]);

  if (isCartEmpty) return null;

  return children;
};

export default ProtectedCheckout;